import axios from 'axios';

export const getAdvertiserBillingInfo = async id =>
  axios.get(`/advertiser/${id}/billing/`).then(res => res.data);

export const getAgencyBillingInfo = async id =>
  axios.get(`/agency/${id}/billing/`).then(res => res.data);
